<template>
  <div class="custom-control custom-checkbox">
    <input
      type="checkbox"
      class="custom-control-input"
      :checked="modelValue === value"
      :id="uuid"
      v-bind="{ ...$attrs, onChange: updateValue }"
    />
    <label
        v-if="label"
        :for="uuid"
        class="custom-control-label"
    >
      {{ label }}
    </label>
    <ErrorMessage
        v-if="error"
        :id="`${uuid}-error`"
    >
      {{ error }}
    </ErrorMessage>
  </div>
</template>

<script>
import UniqueID from '@/Lib/UniqueID'
import SetupFormComponent from '@/Lib/SetupFormComponent'

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number, Array]
    },
    value: {
      type: [String, Number, Array]
    },
    error: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const uuid = UniqueID().getID()
    const { updateValue } = SetupFormComponent(props, context)

    const updateValuex = (event) => {
      let modelValue = [...props.modelValue],
          val = props.value

      if (event.target.checked) {
        modelValue.push(val)
      } else {
        modelValue.splice(modelValue.indexOf(val), 1)
      }

      context.emit('update:modelValue', modelValue)
    }

    return {
      updateValuex,
      updateValue,
      uuid
    }
  }
}
</script>
